/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PauseSubscriptionRequest = {
  /**
   * The unique identifier of the subscription
   */
  id: string;
};

/** @internal */
export const PauseSubscriptionRequest$inboundSchema: z.ZodType<
  PauseSubscriptionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
});
/** @internal */
export type PauseSubscriptionRequest$Outbound = {
  id: string;
};

/** @internal */
export const PauseSubscriptionRequest$outboundSchema: z.ZodType<
  PauseSubscriptionRequest$Outbound,
  z.ZodTypeDef,
  PauseSubscriptionRequest
> = z.object({
  id: z.string(),
});

export function pauseSubscriptionRequestToJSON(
  pauseSubscriptionRequest: PauseSubscriptionRequest,
): string {
  return JSON.stringify(
    PauseSubscriptionRequest$outboundSchema.parse(pauseSubscriptionRequest),
  );
}
export function pauseSubscriptionRequestFromJSON(
  jsonString: string,
): SafeParseResult<PauseSubscriptionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PauseSubscriptionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PauseSubscriptionRequest' from JSON`,
  );
}
